/**
 * Verified Google review proof.
 *
 * This is intentionally a static snapshot. The public Google Maps listing was
 * checked on 2026-09-01; update `verifiedOn`, the aggregate, and excerpts
 * together whenever the snapshot is refreshed. Keep every review excerpt
 * short and verbatim, and never infer a reviewer's full name from partial
 * public attribution.
 */
export const googleReviewProof = {
  source: "Google",
  rating: 4.9,
  reviewCount: 53,
  verifiedOn: "2026-09-01",
  placeId: "ChIJ042p-N_ta4cRPwE3ImHrr-k",
  listingHref:
    "https://www.google.com/maps/search/?api=1&query=Front+Range+Cargo+Bikes&query_place_id=ChIJ042p-N_ta4cRPwE3ImHrr-k",
  reviews: [
    {
      author: "Elisa M.",
      rating: 5,
      quote: "Since then, I’ve ridden it over 13,000 miles and it’s still going strong.",
    },
    {
      author: "Stephanie",
      rating: 5,
      quote:
        "They also have Thule seats available to trial with kids on some bikes, which was a huge help to us.",
    },
    {
      author: "Derek S.",
      rating: 5,
      quote:
        "They took the time to walk us through different bikes, test out multiple options, and ultimately find what best fits our family and goals.",
    },
    {
      author: "Miriam B.",
      rating: 5,
      quote:
        "Ryan is so kind, knowledgeable, and helpful when purchasing and maintaining a cargo bike.",
    },
    {
      author: "Robert A.",
      rating: 5,
      quote:
        "Fantastic sales and aftercare. I would definitely recommend Ryan to anyone shopping for a cargo bike.",
    },
    {
      author: "Matthew B.",
      rating: 5,
      quote: "We have had nothing but stellar experiences with Front Range Cargo Bikes.",
    },
    {
      author: "Sebastian S.",
      rating: 5,
      quote: "The owners are clearly dedicated to their cause and are always happy to help out their customers.",
    },
    {
      author: "Eric Y.",
      rating: 5,
      quote:
        "The team is knowledgeable and friendly, you can tell they really enjoy what they do and care about their customers.",
    },
    {
      author: "Trevor G.",
      rating: 5,
      quote:
        "The web of people we know who we've referred to Front Range Cargo Bikes includes at least six families and 10 different bikes purchased!",
    },
    {
      author: "Gregory M.",
      rating: 5,
      quote: "What a pleasant buying experience!",
    },
    {
      author: "Andrew M.",
      rating: 5,
      quote: "We came by Front Range Cargo Bikes to look for and test drive a cargo bike.",
    },
    {
      author: "Dustin N.",
      rating: 5,
      quote:
        "They prefer to let the bikes sell themselves and have a true passion to make sure anyone who comes in knows as much as they want about the bikes.",
    },
    {
      author: "Rylee K.",
      rating: 5,
      quote:
        "I so appreciated that there were stuffed animals and such to entertain my active toddler while I shopped!",
    },
    {
      author: "Sky C.",
      rating: 5,
      quote: "Wonderful bike shop with excellent customer service.",
    },
    {
      author: "Adria",
      rating: 5,
      quote: "A great shop for finding just the right bike to transport your kids (or stuff).",
    },
    {
      author: "Jawad M.",
      rating: 5,
      quote: "They had multiple cargo bikes in their demo fleet.",
    },
    {
      author: "Kevin Y.",
      rating: 5,
      quote: "Ryan and his team are very knowledgeable and give very helpful support.",
    },
    {
      author: "Bonnie G.",
      rating: 5,
      quote: "He has consistently helped me with everything I wanted and needed.",
    },
  ],
} as const;
